import CardInputGroup from '../../../../components/mazraeKit/CardInputGroup';
import {InputNameToGroupName} from '../../../../pages/farm/advertisementList/utils';
import DotsLoading from '../../../../components/dotsLoading';

interface IFiltersKeyValuePairs {
  guid: string;
  title: string;
  code: number;
}

// Both keys are allowed; each is optional so callers can pass either shape
interface IFiltersShape {
  categories?: Array<IFiltersKeyValuePairs>;
  sub_categories?: Array<IFiltersKeyValuePairs>;
}

type FilterKey = keyof IFiltersShape; // 'categories' | 'sub_categories'

interface SubCategoryCardsProps<T extends IFiltersShape> {
  subInputGroupList: Array<IInputLists>;
  filters?: T;
  setFilters?: React.Dispatch<React.SetStateAction<T>>;
  isSubCategory?: boolean;
}

const SubCategoryCards = <T extends IFiltersShape>({
  subInputGroupList,
  filters,
  setFilters,
  isSubCategory = false,
}: SubCategoryCardsProps<T>) => {
  const targetField: FilterKey = isSubCategory
    ? 'sub_categories'
    : 'categories';

  const choosingHandler = (
    inputGroupItem: Omit<IInputLists, 'title_description' | 'icon'>,
  ) => {
    const found = filters?.[targetField]?.some(
      el => el?.guid === inputGroupItem?.guid,
    );

    if (!setFilters) return;

    if (found) {
      setFilters(prev => ({
        ...prev,
        [targetField]: (prev[targetField] ?? []).filter(
          item => item?.guid !== inputGroupItem?.guid,
        ),
      }));
    } else {
      setFilters(prev => ({
        ...prev,
        [targetField]: [
          ...(prev[targetField] ?? []),
          {
            guid: inputGroupItem.guid,
            title: inputGroupItem.title,
            code: inputGroupItem.code,
          },
        ],
      }));
    }
  };

  return (
    <div className="grid grid-cols-4 px-3 w-full">
      {subInputGroupList
        ?.map(item => {
          return {...item, type: InputNameToGroupName[item.code]};
        })
        .map(item => {
          return (
            <div className="flex justify-center w-full" key={item.guid}>
              <CardInputGroup
                isActive={filters?.[targetField]?.some(
                  el => el?.guid === item?.guid,
                )}
                isBoled={false}
                title={item.title}
                image={item.image}
                guid={item?.guid}
                clickHandler={() => choosingHandler(item)}
              />
            </div>
          );
        })}
    </div>
  );
};

export default SubCategoryCards;
